import { get } from "lodash";
import passaroData from './passaroMarron.config.json' with { type: 'json' };
import luxoData from './luxo.config.json' with { type: 'json' };

const findWl = () => {
  const wlConfig = JSON.parse(localStorage.getItem("_wlConfig"));
  return wlConfig ? wlConfig : {};
};

const loadConfig = async (cb) => {
  const isLocalhost =
    window.location.host.indexOf("localhost") > -1 ||
    window.location.host.indexOf("192") > -1;
  // Localhost: choose channel via domain string (JSON configs, no CMS call).
  const params = isLocalhost && {
    domain: 'http://passaromarron-wl-2.dex.company',
    // domain: 'http://app.expressoluxo.com.br'
  };
  const { data } = getConfigJSON(params)
  await localStorage.setItem("_wlConfig", JSON.stringify(data));
  localStorage.setItem("_wlConfigTime", new Date().getTime());
  cb({ data, status: true });
};

const getConfigJSON = (params) => {
  if(params) {
    if(params.domain.indexOf("luxo") > -1) return {data: luxoData};
    else return {data: passaroData};
  } else {
    if(window.location.host.indexOf("luxo") > -1) return {data: luxoData};
    else return {data: passaroData};
  }
}

const getConfig = (queryArray) => {
  const wl = findWl();
  return queryArray.map((queryObj) => {
    try {
      const res = get(wl, queryObj);
      if (!res)
        throw new Error(
          `Config not found for ${queryObj}, in ${JSON.stringify(queryArray)}`
        );
      return res;
    } catch ({ message }) {
      console.log(message);
      return {};
    }
  });
};

export { loadConfig, getConfig, findWl };
